import { render, staticRenderFns } from "./CustomerUserIndex.vue?vue&type=template&id=d0b5f2c2&"
import script from "./CustomerUserIndex.vue?vue&type=script&lang=js&"
export * from "./CustomerUserIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports